var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockUnfilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 0.833984C5.47283 0.833984 3.41675 2.89007 3.41675 5.41732V8.16732H2.50008C1.489 8.16732 0.666748 8.98957 0.666748 10.0007V17.334C0.666748 18.3451 1.489 19.1673 2.50008 19.1673H13.5001C14.5112 19.1673 15.3334 18.3451 15.3334 17.334V10.0007C15.3334 8.98957 14.5112 8.16732 13.5001 8.16732H12.5834V5.41732C12.5834 2.89007 10.5273 0.833984 8.00008 0.833984ZM13.5001 10.0007L13.5019 17.334H2.50008V10.0007H13.5001ZM5.25008 8.16732V5.41732C5.25008 3.90115 6.48391 2.66732 8.00008 2.66732C9.51625 2.66732 10.7501 3.90115 10.7501 5.41732V8.16732H5.25008Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnfilledIcon);
export default __webpack_public_path__ + "static/media/lock-unfilled-icon.a81e83c825914ea7b244a9ec0938f713.svg";
export { ForwardRef as ReactComponent };